// extracted by mini-css-extract-plugin
export default {"background":"InfoModal_background__z+HCN","modal":"InfoModal_modal__A4ZRK","viddo_modal":"InfoModal_viddo_modal__KPOEA","btn_main":"InfoModal_btn_main__Nklyt"};